import { render, staticRenderFns } from "./ClientsUpdateForm.vue?vue&type=template&id=5601e2fa&scoped=true"
import script from "./ClientsUpdateForm.vue?vue&type=script&lang=ts"
export * from "./ClientsUpdateForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5601e2fa",
  null
  
)

export default component.exports